import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import "./index.css";

// Both daksfirst-v2.vercel.app and invest.daksfirst.com serve the same site —
// the merchant-banking home page is the right entry point for both investors and borrowers.
// No host-based rewrites.

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
